import React from "react";
import Therapist from "./Therapist";
import "./TherapistsCard.css";

const TherapistsCard = ({ therapists }) => {
  console.log(therapists);
  return (
    <div className="therapistsCardContainer">
      <div className="therapistsIntroduction">
        We are not a group practice, rather independent therapists working to
        provide therapy in a warm and comforting environment. As such, insurance
        participation, fees, rates, terms, conditions, maintenance and storage
        of records, and hours are determined by each therapist. All of our
        therapists are state licensed and have degrees in their area of
        practice. Whether you are looking for marriage counseling, family
        counseling, or individual counseling, we have caring and professional
        therapists to help you. Arrangements for appointments, services,
        records, and payments must be made with the therapists individually.
        Please select your therapist below to get additional information about
        his or her practice.
      </div>
      <div className="therapistsCards">
        {therapists.map(
          (therapist) => (
            <Therapist key={therapist.id} therapist={therapist} />
          )
          //therapist.FirstName
        )}
      </div>
    </div>
  );
};

export default TherapistsCard;
